<template>
<!-- 能耗监测 -->
    <div class="concrete-box">
        <div class="box-head">
            <p>在建项目：{{num.projectCount}}</p>
            <p>已安装项目数：{{num.install}}</p>
            <p>未安装项目数：{{num.unInstall}}</p>
            <p>联网设备：{{num.totalOnline}}</p>
            <p>离线设备：{{num.totalOffline}}</p>
            <el-input  placeholder="请输入项目名称" v-model="projectName" clearable></el-input>
            <el-button type="primary" @click="doFilter">查询</el-button>
        </div>
        <div class="box-main">
            <el-table :data="tableData" style="width: 100%" border height="100%" :row-class-name="tableRowClassName" :header-row-class-name="'table-head'">
                <template slot="empty">
                    <p>{{dataText}}</p>
                </template>
                <el-table-column prop="index" label="序号" width="200">
                    <template slot-scope="scope">
                        <span>{{scope.row.index}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="projectName" label="项目名称">
                    <template slot-scope="scope">
                        <span>{{scope.row.projectName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="count" label="安装数量">
                    <template slot-scope="scope">
                        <span>{{scope.row.count}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="联网状态">
                    <template slot-scope="scope">
                        <p><span style="color:#00C700;">联网</span><span>{{scope.row.status}}</span></p>
                    </template>
                </el-table-column>
                <el-table-column prop="electricity" label="用量">
                    <template slot-scope="scope">
                        <p style="width:100%;"  v-if="!scope.row.water">水 --</p>
                        <p style="width:100%;"  v-else>水 {{scope.row.water}}吨</p>
                        <p style="width:100%;"  v-if="!scope.row.electricity">电 --</p>
                         <p style="width:100%;" v-else>电 {{scope.row.electricity}}千瓦时</p>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="success" @click="infoFun(scope.row)">查看</el-button>
                    </template>
                </el-table-column> -->
            </el-table>
        </div>
        <!--  -->
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalItems"
        ></el-pagination>
    </div>
</template>
<script>
import myHttp from '../../../untils/port';
import util from '../../../untils/util';
export default {
    data(){
        return{
            groupId:'',
            tableData:[],
            currentPage: 1,
            pageSize: 10,
            totalItems: 0,
            projectName:'',
            dataText: '数据加载中...',
            num:{
                install:0,
                projectCount:0,
                totalOffline:0,
                totalOnline:0,
                unInstall:0
            },
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.getData()
        this.getNum()
    },
    methods:{
        handleSizeChange(val) {
            this.pageSize = val
            this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.currentChangePage()
        },
        // 监控当前页码
        currentChangePage(list) {
            this.getData()
        },
        doFilter(){
            this.currentPage = 1
            this.getData()
        },
        //获取列表
        getData(){
            var that = this
            myHttp.selectElectricityList({
                entId:this.groupId,
                joinType:'3',
                projectName:this.projectName,
                pageNum:this.currentPage,
                pageSize:this.pageSize
            }).then(function(resp){
                console.log(resp)
                if(resp.data.code=='200'){
                    var list = resp.data.data.PageInfo.list||[]
                    for(var i=0;i<list.length;i++){
                        list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
                    }
                    that.tableData = list
                    that.totalItems = resp.data.data.PageInfo.total||0
                    if (that.tableData.length == 0) {
                        that.dataText = '暂无数据'
                    }
                }
            })
        },
        //获取数量
        getNum(){
            var that = this
            myHttp.selectWaterElectricityCount({
                entId:this.groupId,
                joinType:'3'
            }).then(function(resp){
                console.log(resp)
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    if(data){
                        that.num = data
                    }
                }
            })
        },
        //
        tableRowClassName({row, rowIndex}) {
            if (rowIndex%2==1) {
                return 'grey-row';
            }else{
                return '';
            }
            return '';
        },
        //查看
        infoFun(row){

        },
    }
}
</script>

<style scoped>
    .concrete-box{
        width: 100%;
        height: 100%;
        position: relative;
        padding: 1vh;
    }
    .box-head{
        width: 100%;
        height: 7vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding: 0 1vw;
        background: #fff;
    }
    .box-main{
        width: 100%;
        height: calc( 100% - 12vh );
        position: relative;
        background: #fff;
    }
    .grey-row{
        background: #F2F2F7;
    }
    .box-head p{
        width: 12vw;
        position: relative;
        text-align: left;
    }
</style>

<style>
    @import '../../../assets/css/common.css';
    /* .el-table .table-head{
        background-color: #F2F2F7;
    } */
    .concrete-box .el-table th.table-head,.concrete-box .el-table tr.table-head {
        background-color: #F2F2F7 !important;
    }
    .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    }
</style>